module.exports = __webpack_public_path__ + "static/media/build-loader.04242a3d.gif";